import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import { change_sub_admin_status, create_sub_admin, delete_sub_admin, get_sub_admin, update_sub_admin } from '../../utils/api-routes';

function* getSubAdmin() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_sub_admin}`);
        console.log("Get Sub Admin Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_SUB_ADMIN, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Sub Admin Saga Error ::: ", error)
    }
}

function* createSubAdmin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_sub_admin}`, payload?.data);
        console.log("Create Sub Admin Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Sub Admin Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create Sub Admin',
            text: "Failed To Create Sub Admin",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Sub Admin Saga Error ::: ", error?.response?.data)
    }
}

function* updateSubAdmin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_sub_admin}`, payload?.data);
        console.log("Update Sub Admin Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Sub Admin Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_SUB_ADMIN, payload: null })
        }

    } catch (error) {
        console.log("Update Sub Admin Saga Error ::: ", error?.response?.data)
    }
}

function* deleteSubAdmin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_sub_admin}`, payload);
            console.log("Delete Sub Admin Saga Response ::: ", data)
            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Sub Admin Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_SUB_ADMIN, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete Sub Admin",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Sub Admin Saga Error ::: ", error?.response?.data)
    }
}

function* changeSubAdminStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_sub_admin_status}`, payload);
            console.log("Change Sub Admin Status Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_SUB_ADMIN, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Sub Admin Status Saga Error ::: ", error?.response?.data)
    }
}

export default function* subAdminSaga() {
    yield takeLeading(actionTypes?.GET_SUB_ADMIN, getSubAdmin);
    yield takeLeading(actionTypes?.CREATE_SUB_ADMIN, createSubAdmin);
    yield takeLeading(actionTypes?.UPDATE_SUB_ADMIN, updateSubAdmin);
    yield takeLeading(actionTypes?.DELETE_SUB_ADMIN, deleteSubAdmin);
    yield takeLeading(actionTypes?.CHANGE_SUB_ADMIN_STATUS, changeSubAdminStatus);
}
